import {
  Container,
  Grid,
  Heading,
  LinkBox,
  LinkOverlay,
  Text,
} from '@chakra-ui/react'

import Head from 'next/head'
import Link from 'next/link'
import { MainLayout } from '@/layouts'
import { PostCard } from '@/components'
import { PostsPageProps } from '@/pages/posts'

const Posts = (props: PostsPageProps) => {
  const postItems = props.allPost?.map((post) => (
    <LinkBox key={post.id}>
      <Link href={`/posts/${post.slug}`} passHref>
        <LinkOverlay>
          <PostCard
            postTitle={post.postTitle}
            slug={post.slug}
            tag={post.type}
            views={post.views}
            publishDate={post.publishDate}
            outlineColor={post.outlineColor}
            highlightColor={post.highlightColor}
          />
        </LinkOverlay>
      </Link>
    </LinkBox>
  ))
  return (
    <MainLayout>
      <Head>
        <title>Posts | Chacra Software Solutions</title>
      </Head>
      <Container maxWidth="container.xl" textAlign="left" py={20} minH="100vh">
        <Heading as="h1" fontSize="6xl" mb="4">
          Blogs &amp; Articles
        </Heading>
        <Text fontSize="xl" mb="8">
          We stay up to date with the latest technologies and industry news by
          researching and summarizing what we find in the simplest terms
          possible. If you can&apos;t explain something simply then you simply
          don&apos;t understand it well enough.
        </Text>
        <Grid
          templateColumns={{
            base: 'repeat(1,1fr)',
            md: 'repeat(2,1fr)',
            lg: 'repeat(3,1fr)',
          }}
          gap="10"
        >
          {postItems && postItems}
        </Grid>
      </Container>
    </MainLayout>
  )
}

export default Posts
